/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div

      >
        <main>{children}</main>
        <footer style={{backgroundColor:"#23263a",color:"#fff",textAlign:"center",paddingTop:"20px",paddingBottom:"20px"}}>
          Copyright © {new Date().getFullYear()}
          <a style={{color:"#ff4a57", textDecoration:"none"}} href="/"> Chirag Jain</a> All Rights Reserved
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
